/* eslint-disable */

import { TUnitType } from '../api/analytics/UnitType';
import { ColumnRangeData, RoundChartData, TreemapData } from '../types/charts/chart-options';
import { DraggableMenuItemData } from '../types/databuilder/databuilder';
import { calculatePercentage, ChartDataResponse } from './chart.helper';

export const getDefaultSingleSeriesData = (
	chartData: object[],
	unitType?: TUnitType,
	selected2ndUnitType?: TUnitType,
	numberOfDecimals?: number,
	droppedFactsCount?: number,
	chartColor?: string,
	grandTotal?: [{ [key: string]: number }],
	showPercentages?: boolean,
	droppedFacts?: DraggableMenuItemData[]
) => {
	const response: ChartDataResponse = {
		xAxisArray: [],
		yAxisArray: [],
		valueArray: [],
		valueArray2: [],
		seriesData: [],
		lookupData: [[], []],
	};
	const singleSeriesFinalArray: RoundChartData = { data: [], data2: [] };

	if (chartData) {
		chartData.map((value) => {
			const hasThree = Object.keys(value).length > 2;
			type ObjectKey = keyof typeof value;
			Object.keys(value).map((key: string, index: number) => {
				const prop = key as ObjectKey;

				if (index === 0) {
					response.xAxisArray.push(value[prop] as string);
				}

				const percentage = calculatePercentage(
					(prop as string).replace(/([A-Z])/g, ' $1').trim(),
					grandTotal,
					value[prop] as number | null | undefined
				);

				const total = !showPercentages
					? (value[prop] as string)
					: percentage
					? percentage.toString()
					: '0';

				if (hasThree) {
					if (index === 1) {
						response.valueArray2.push(total);
					} else if (index === 2) {
						response.valueArray.push(total);
					}
				} else {
					if (index === 1) {
						response.valueArray.push(total);
					}
				}
			});
		});
	}

	if (chartData) {
		const numberOfDecimalsSeries1 =
			droppedFacts && droppedFacts?.length > 0
				? droppedFacts[0]?.data?.numDecimals
				: numberOfDecimals;
		const numberOfDecimalsSeries2 =
			droppedFacts && droppedFacts?.length > 1
				? droppedFacts[1]?.data?.numDecimals
				: numberOfDecimals;

		const hasCalculatedFacts =
			droppedFactsCount &&
			droppedFactsCount > 1 &&
			droppedFacts?.some((fact) => fact.data?.calculated);

		const numCalculatedFacts =
			droppedFactsCount &&
			droppedFactsCount > 1 &&
			droppedFacts?.filter((fact) => fact.data?.calculated).length;

		const calcFact = droppedFacts?.find((fact) => fact.data?.calculated);
		const calcFactIdx = droppedFacts?.findIndex((item) => item === calcFact);
		const calcFactIsFirstIdx = calcFactIdx == 0;

		chartData.map((_value, index) => {
			//TODO: update so the plotValue var matches up with the valueArray var
			let plotValue = parseFloat(response.valueArray2[index]);
			let plotValue2 = parseFloat(response.valueArray[index]);

			if (hasCalculatedFacts && calcFactIsFirstIdx && numCalculatedFacts == 1) {
				plotValue = parseFloat(response.valueArray[index]);
				plotValue2 = parseFloat(response.valueArray2[index]);
			}

			const keys = Object.keys(_value);
			const categoryValue = response.xAxisArray[index];

			// Grab raw numeric values from original chartData
			const rawValue1 = keys[1] ? Number((_value as any)[keys[1]]) || 0 : 0;
			const rawValue2 = keys[2] ? Number((_value as any)[keys[2]]) || 0 : 0;

			if (!showPercentages) {
				if (unitType?.code === 'PCT') {
					plotValue = plotValue * 100;
				}

				if (
					selected2ndUnitType?.code === 'PCT' ||
					(droppedFactsCount && droppedFactsCount == 1 && unitType?.code === 'PCT')
				) {
					plotValue2 = plotValue2 * 100;
				}
			}

			//for some reason if the arrays dont have the exact same 'y' and 'value' props then it wont reflect in final list
			singleSeriesFinalArray.data.push({
				name: categoryValue,
				y: parseFloat(plotValue.toFixed(numberOfDecimalsSeries1)),
				value: rawValue1,
			});
			singleSeriesFinalArray.data2.push({
				name: categoryValue,
				y: parseFloat(
					plotValue2.toFixed(
						isNaN(plotValue) ? numberOfDecimalsSeries1 : numberOfDecimalsSeries2
					)
				),
				value: rawValue1,
			});
		});

		const seriesName1 =
			droppedFacts && droppedFacts?.length > 0 ? droppedFacts[0]?.data?.title : 'series 1';

		const seriesName2 =
			droppedFacts && droppedFacts?.length > 0 ? droppedFacts[1]?.data?.title : 'series 2';

		const firstSeriesName = seriesName1;
		const secondSeriesName = seriesName2;

		response.seriesData = [
			{
				name: firstSeriesName,
				data:
					droppedFactsCount && droppedFactsCount > 1
						? singleSeriesFinalArray.data
						: singleSeriesFinalArray.data2 ?? [],
				color: chartColor,
			},
		];

		if (droppedFactsCount && droppedFactsCount > 1) {
			response.seriesData.push({
				name: secondSeriesName,
				data: singleSeriesFinalArray.data2 ?? [],
				type: 'line',
				color: '#ABB8C3',
				yAxis: 1,
				colorAxis: 1,
			});
		}
	}

	return response;
};

export const getOdometerData = (
	chartData: object[],
	unitType?: TUnitType,
	numberOfDecimals?: number,
	grandTotal?: [{ [key: string]: number }],
	showPercentages?: boolean
) => {
	const response: ChartDataResponse = {
		xAxisArray: [],
		yAxisArray: [],
		valueArray: [],
		valueArray2: [],
		seriesData: [],
		lookupData: [[], []],
	};

	if (chartData) {
		chartData.map((value) => {
			type ObjectKey = keyof typeof value;
			Object.keys(value).map((key: string, index: number) => {
				const prop = key as ObjectKey;

				if (index === 0) {
					response.xAxisArray.push(value[prop] as string);
				}
				if (index === 1) {
					const percentage = calculatePercentage(
						(prop as string).replace(/([A-Z])/g, ' $1').trim(),
						grandTotal,
						value[prop] as number | null | undefined
					);

					response.valueArray.push(
						!showPercentages
							? (value[prop] as string)
							: percentage
							? percentage.toString()
							: '0'
					);
				}
			});
		});

		const odometerFinalArray = chartData.map((_value, index) => {
			let plotValue = parseFloat(response.valueArray[index]);

			if (showPercentages || unitType?.code === 'PCT') {
				plotValue = plotValue * 100;
			}

			return parseFloat(plotValue.toFixed(numberOfDecimals));
		});

		response.seriesData = [
			{
				name: response.xAxisArray[0],
				data: odometerFinalArray ?? [],
			},
		];
	}

	return response;
};

export const getColumnRangeData = (
	chartData: object[],
	unitType?: TUnitType,
	numberOfDecimals?: number,
	chartColor?: string,
	grandTotal?: [{ [key: string]: number }],
	showPercentages?: boolean,
	droppedFacts?: DraggableMenuItemData[]
) => {
	const response: ChartDataResponse = {
		xAxisArray: [],
		yAxisArray: [],
		valueArray: [],
		valueArray2: [],
		seriesData: [],
		lookupData: [[], []],
	};
	const singleSeriesFinalArray: ColumnRangeData = { data: [] };

	if (chartData) {
		chartData.map((value) => {
			const hasThree = Object.keys(value).length > 2;
			type ObjectKey = keyof typeof value;
			Object.keys(value).map((key: string, index: number) => {
				const prop = key as ObjectKey;

				if (index === 0) {
					response.xAxisArray.push(value[prop] as string);
				}

				const percentage = calculatePercentage(
					(prop as string).replace(/([A-Z])/g, ' $1').trim(),
					grandTotal,
					value[prop] as number | null | undefined
				);

				const total = !showPercentages
					? (value[prop] as string)
					: percentage
					? percentage.toString()
					: '0';

				if (hasThree) {
					if (index === 1) {
						response.valueArray2.push(total);
					} else if (index === 2) {
						response.valueArray.push(total);
					}
				} else {
					if (index === 1) {
						response.valueArray.push(total);
					}
				}
			});
		});
	}

	if (chartData) {
		const numberOfDecimalsSeries1 =
			droppedFacts && droppedFacts?.length > 0
				? droppedFacts[0]?.data?.numDecimals
				: numberOfDecimals;
		const numberOfDecimalsSeries2 =
			droppedFacts && droppedFacts?.length > 1
				? droppedFacts[1]?.data?.numDecimals
				: numberOfDecimals;

		chartData.map((_value, index) => {
			let plotValue = parseFloat(response.valueArray2[index]);
			let plotValue2 = parseFloat(response.valueArray[index]);

			if (!showPercentages) {
				if (unitType?.code === 'PCT') {
					plotValue = plotValue * 100;
					plotValue2 = plotValue2 * 100;
				}
			}

			const low = plotValue >= plotValue2 ? plotValue2 : plotValue;
			const high = plotValue >= plotValue2 ? plotValue : plotValue2;

			const columnRangeData: [number, number] = [
				parseFloat(low.toFixed(numberOfDecimalsSeries1)),
				parseFloat(
					high.toFixed(
						isNaN(plotValue) ? numberOfDecimalsSeries1 : numberOfDecimalsSeries2
					)
				),
			];

			singleSeriesFinalArray.data.push(columnRangeData);
		});

		response.seriesData = [
			{
				name:
					droppedFacts && droppedFacts?.length > 0
						? droppedFacts[0]?.data?.title
						: 'series 1',
				data: singleSeriesFinalArray.data,
				color: chartColor,
			},
		];
	}

	return response;
};

export const getTreemapSquarifiedData = (
	chartData: object[],
	unitType?: TUnitType,
	numberOfDecimals?: number,
	grandTotal?: [{ [key: string]: number }],
	showPercentages?: boolean,
	droppedFacts?: DraggableMenuItemData[]
) => {
	const response: ChartDataResponse = {
		xAxisArray: [],
		yAxisArray: [],
		valueArray: [],
		valueArray2: [],
		seriesData: [],
		lookupData: [[], []],
	};
	const singleSeriesFinalArray: TreemapData = { data: [] };

	if (chartData) {
		chartData.map((value) => {
			const hasThree = Object.keys(value).length > 2;
			type ObjectKey = keyof typeof value;
			Object.keys(value).map((key: string, index: number) => {
				const prop = key as ObjectKey;

				if (index === 0) {
					response.xAxisArray.push(value[prop] as string);
				}

				const percentage = calculatePercentage(
					(prop as string).replace(/([A-Z])/g, ' $1').trim(),
					grandTotal,
					value[prop] as number | null | undefined
				);

				const total = !showPercentages
					? (value[prop] as string)
					: percentage
					? percentage.toString()
					: '0';

				if (hasThree) {
					if (index === 1) {
						response.valueArray2.push(total);
					} else if (index === 2) {
						response.valueArray.push(total);
					}
				} else {
					if (index === 1) {
						response.valueArray.push(total);
					}
				}
			});
		});
	}

	if (chartData) {
		chartData.map((_value, index) => {
			let plotValue =
				response.valueArray2[index] && response.valueArray2[index].length > 0
					? parseFloat(response.valueArray2[index])
					: parseFloat(response.valueArray[index]);

			const categoryValue = response.xAxisArray[index];
			const keys = Object.keys(_value);

			// Grab raw numeric values from original chartData
			const rawValue1 = keys[1] ? Number((_value as any)[keys[1]]) || 0 : 0;
			const rawValue2 = keys[2] ? Number((_value as any)[keys[2]]) || 0 : 0;

			if (!showPercentages) {
				if (unitType?.code === 'PCT') {
					plotValue = plotValue * 100;
				}
			}

			singleSeriesFinalArray.data.push({
				name: categoryValue,
				value: rawValue1,
				y: parseFloat(plotValue.toFixed(numberOfDecimals)),
			});
		});

		const firstSeriesName =
			droppedFacts && droppedFacts?.length > 0 ? droppedFacts[0]?.data?.title : 'series 1';

		response.seriesData = [
			{
				name: firstSeriesName,
				data: singleSeriesFinalArray.data,
			},
		];
	}

	return response;
};
